import { AddDataPribadiPayload } from "../../../../models/DataPribadi";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { dataPribadiKey } from "../../queries/DataPribadi/useFetchDataPribadi";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";

export async function addDataPribadi(data: AddDataPribadiPayload) {
  const res = await ApiClient.post(`/AddDataPribadi`, data);
  return res.data;
}

export const useAddDataPribadi = mutationWrapper(addDataPribadi, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(dataPribadiKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
